import { useTranslation } from "react-i18next";

export type ViewMode = "worker" | "workorder-crane";

interface ViewToggleProps {
  value: ViewMode;
  onChange: (v: ViewMode) => void;
  onPrefetch?: (v: ViewMode) => void;
}

export function ViewToggle({ value, onChange, onPrefetch }: ViewToggleProps) {
  const { t } = useTranslation();
  const segments: { key: ViewMode; label: string }[] = [
    { key: "worker", label: t("admin.uren.view-toggle.worker") },
    { key: "workorder-crane", label: t("admin.uren.view-toggle.workorder-crane") },
  ];
  return (
    <div
      role="tablist"
      aria-label="View toggle"
      className="inline-flex rounded-md border border-line bg-surface text-sm"
    >
      {segments.map((s) => (
        <button
          key={s.key}
          role="tab"
          aria-selected={value === s.key}
          onClick={() => onChange(s.key)}
          onMouseEnter={onPrefetch ? () => onPrefetch(s.key) : undefined}
          onFocus={onPrefetch ? () => onPrefetch(s.key) : undefined}
          className={`px-3 py-1.5 text-xs ${value === s.key ? "bg-p-100 text-p-700 font-semibold" : "text-ink-700 hover:bg-ink-50"}`}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
